import React, { useEffect, useState } from "react";
import PageTitle from "../../../Module/pageTitle";
import LabelField from "../../../Component/labelField";
import CustomDropdown from "../../../Component/customDropdown";
import { useDispatch } from "react-redux";
import {
  addTeacherData,
  getAllTeachersList,
  getExamListNew,
  getParentCourseNew,
  uploadTeacherImg,
  uploadYoutubeReferredImage,
} from "../../../Action/courseAction";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import AddMorebtn from "../../../Component/addMoreBtn";
import ImagePickerAndViewer from "../../../Component/imagePickerAndViewer";
import {
  containsNumber,
  image_size_150,
  length_Five,
  length_Ten,
  length_TwoHundred,
  pdf_size_1MB,
  validateIsFileImageType,
} from "../../../Utils/validators";
import { showErrorSnackbar } from "../../../Action/snackbarAction";
import { validateIsFileImageTypeErrMsg } from "../../../Utils/errorMsg";
import InputField from "../../../Component/inputField";
import {
  getLanguage,
  getSubExam,
  getSubjectList,
} from "../../../Action/adminPanelAction";
import FormInputField from "../../../Component/FormInputField";
import SubmitButton from "../../../Component/SubmitButton";
import Dropdown from "../../../Component/dropdown";

const AddFreeYTLectures = () => {
  //other calling
  const dispatch = useDispatch();
  const [examName, setExamName] = useState("");
  const [subExamName, setSubExamName] = useState("");
  const [parentCourseVal, setParentCourseVal] = useState("");
  const [subjectVal, setSubjectVal] = useState("");
  const [teacherName, setTeacherName] = useState("");
  const [teacherImage, setTeacherImage] = useState("");
  const [selectedImage, setSelectedImage] = useState("");
  // const [order, setOrder] = useState("");
  const [examList, setExamList] = useState([]);
  const [subExamList, setSubExamList] = useState([]);
  const [parentCourseList, setParentCourseList] = useState([]);
  const [teacherList, setTeacherList] = useState([]);
  const [resetExam, setResetExam] = useState(false);
  const [resetSubExam, setResetSubExam] = useState(false);
  const [resetParentCourse, setResetParentCourse] = useState(false);
  const [resetTeacherList, setResetTeacherList] = useState(false);
  const initialValPremier = {
    topic: "",
    title: "",
    thumbnail: "",
    url: "",
    awsUrl: "",
    order: "",
    languageId: "",
  };
  //states
  const [premierdateArr, setpremierdateArr] = useState([initialValPremier]);
  const [subjectList, setSubjectList] = useState([]);
  const [languageList, setLanguageList] = useState([]);

  useEffect(() => {
    dispatch(
      getLanguage((res) => {
        setLanguageList(res.data.data);
      })
    );
  }, []);
  //functionality
  const onChangeData = (value, type) => {
    if (type === "examName") {
      setExamName(value);
      setResetExam(false);
      setSubExamName("");
      setParentCourseVal("");
      setTeacherName("");
      setTeacherImage("");
      setSelectedImage("");
      setSubExamList([]);
      setParentCourseList([]);
      setTeacherList([]);
      setResetSubExam(true);
      setResetParentCourse(true);
      setResetTeacherList(true);
      dispatch(
        getSubExam(
          {
            examTypeId: value._id,
          },
          (res) => {
            if (res?.data.length > 0) {
              setSubExamList(res?.data);
            } else {
              dispatch(
                getParentCourseNew(`${value._id}`, (res) => {
                  setParentCourseList(res);
                })
              );
            }
          }
        )
      );
    } else if (type === "subExam") {
      setSubExamName(value);
      setParentCourseVal("");
      setTeacherName("");
      setTeacherImage("");
      setSelectedImage("");
      setParentCourseList([]);
      setTeacherList([]);
      setResetSubExam(false);
      setResetParentCourse(true);
      setResetTeacherList(true);
      dispatch(
        getParentCourseNew(`${examName._id}/${value._id}`, (res) => {
          setParentCourseList(res);
        })
      );
    } else if (type === "parentCourse") {
      setParentCourseVal(value);
      setTeacherName("");
      setTeacherImage("");
      setSelectedImage("");
      setTeacherList([]);
      setResetParentCourse(false);
      setResetTeacherList(true);
      dispatch(
        getAllTeachersList(
          {
            skip: 0,
            limit: 100,
          },
          (res) => {
            setTeacherList(res?.data?.data);
          },
          () => {}
        )
      );
      dispatch(
        getSubjectList(
          {
            examTypeId: examName._id,
            subExamTypeId: subExamName._id,
            baseCourseId: value?._id,
          },
          (res) => {
            if (res) {
              setSubjectList(res?.data);
            }
          }
        )
      );
    } else if (type === "teachers") {
      setTeacherName(value);
      setTeacherImage("");
      setSelectedImage("");
      setResetTeacherList(false);
    } else if (type === "subject") {
      setSubjectVal(value);
      setTeacherName("");
      setTeacherImage("");
      setSelectedImage("");
    }
  };

  const handleTeacherImg = (e) => {
    e.preventDefault();
    if (!validateIsFileImageType(e)) {
      dispatch(showErrorSnackbar(validateIsFileImageTypeErrMsg));
      return;
    }
    if (e.target.files[0].size > image_size_150) {
      dispatch(showErrorSnackbar("File size should be less than 150 KB!!!"));
    } else {
      const reader = new FileReader();
      const file = e.target.files[0];
      reader.onloadend = () => {
        setTeacherImage(reader?.result);
        setSelectedImage(file);
      };
      reader.readAsDataURL(file);
    }
  };

  const handelChangeOrder = (value) => {
    if (containsNumber(value) || value === "") {
      // setOrder(value);
    }
  };

  const renderFirstForm = () => {
    return (
      <div className="col-auto">
        <div className="d-flex">
          <LabelField labelName={"Exam Name"} isRequired={true} />
          <CustomDropdown
            setInputText={(value) => onChangeData(value, "examName")}
            value={examName}
            options={examList}
            labelName="Select Exam Name"
            reset={resetExam}
          />
        </div>
        {subExamList?.length > 0 ? (
          <div className="d-flex">
            <LabelField labelName={"Sub Exam Name"} isRequired={true} />
            <CustomDropdown
              setInputText={(value) => onChangeData(value, "subExam")}
              value={subExamName}
              options={subExamList}
              labelName="Select Sub Exam Name"
              reset={resetSubExam}
            />
          </div>
        ) : null}
        <div className="d-flex">
          <LabelField labelName={"Exam Stream"} isRequired={true} />
          <CustomDropdown
            setInputText={(value) => onChangeData(value, "parentCourse")}
            value={parentCourseVal}
            options={parentCourseList}
            labelName="Select Exam Name"
            reset={resetParentCourse}
          />
        </div>
        <div className="d-flex">
          <LabelField labelName={"Subject"} isRequired={true} />
          <CustomDropdown
            setInputText={(value) => onChangeData(value, "subject")}
            value={subjectVal}
            options={subjectList}
            labelName="Select Subject"
            reset={resetParentCourse}
          />
        </div>
        <div className="d-flex">
          <LabelField labelName={"Teacher Name"} isRequired={true} />
          <CustomDropdown
            setInputText={(value) => onChangeData(value, "teachers")}
            value={teacherName}
            options={teacherList}
            labelName="Select Teacher Name"
            reset={resetTeacherList}
          />
        </div>

        <ImagePickerAndViewer
          labelName={"Upload Teacher Image"}
          value={teacherImage}
          handleChange={(e) => handleTeacherImg(e)}
          htmlFor={"photo-upload"}
          isRequired={true}
        />
      </div>
    );
  };
  const handleClosePremier = (index) => {
    const newArrrPrem = [...premierdateArr];
    if (index > -1) {
      newArrrPrem.splice(index, 1);
    }
    setpremierdateArr(newArrrPrem);
  };
  const onPressAddPremier = () => {
    setpremierdateArr([...premierdateArr, initialValPremier]);
  };
  const renderThirdForm = () => {
    return (
      <div>
        {premierdateArr?.map((item, index) => {
          const { topic, title, thumbnail, url, awsUrl, order, languageId } =
            item;
          return (
            <div key={index}>
              <div>
                <LabelField labelName={`Lecture ${index + 1}`} />
                <div className="card p-2 mt-2 mb-4">
                  <span className="d-flex justify-content-end p-2 removeButton">
                    {premierdateArr?.length === 1 ? null : (
                      <HighlightOffIcon
                        className="cursor"
                        color="primary"
                        fontSize="small"
                        onClick={() => handleClosePremier(index)}
                      />
                    )}
                  </span>
                  <div className="d-flex flex-column">
                    <div className="d-flex">
                      <LabelField labelName={`Topic`} isRequired={true} />
                      <FormInputField
                        value={topic}
                        placeholder={`Enter Lecture Topic`}
                        setInputText={(value) =>
                          onChangePremData(value, index, "topic")
                        }
                        minLength={length_Five}
                        maxLength={length_TwoHundred}
                      />
                    </div>
                    <div className="d-flex">
                      <LabelField labelName={`Title`} isRequired={true} />
                      <FormInputField
                        value={title}
                        placeholder={`Enter Lecture Title`}
                        setInputText={(value) =>
                          onChangePremData(value, index, "title")
                        }
                        minLength={length_Five}
                        maxLength={length_TwoHundred}
                      />
                    </div>

                    <div className="d-flex">
                      <LabelField
                        labelName={"Priority Order"}
                        isRequired={true}
                      />
                      <FormInputField
                        value={order}
                        placeholder={`Enter Priority Order`}
                        setInputText={(value) =>
                          onChangePremData(value, index, "order")
                        }
                        maxLength={5}
                      />
                    </div>

                    <ImagePickerAndViewer
                      labelName={"Thumbnail Image"}
                      value={
                        premierdateArr[index].local ||
                        premierdateArr[index].thumbnail ||
                        ""
                      }
                      handleChange={(value) =>
                        onChangePremData(value, index, "thumbnail")
                      }
                      htmlFor={`photo-upload1+${index + 1}`}
                      type="file"
                      isRequired={true}
                    />

                    <div className="d-flex">
                      <LabelField labelName={`Url`} />
                      <FormInputField
                        value={url}
                        placeholder={`Enter Lecture Url`}
                        setInputText={(value) =>
                          onChangePremData(value, index, "url")
                        }
                        minLength={length_Ten}
                        maxLength={length_TwoHundred}
                      />
                    </div>
                    <div className="d-flex">
                      <LabelField labelName={`AWS Url`} />
                      <FormInputField
                        value={awsUrl}
                        placeholder={`Enter AWS Url`}
                        setInputText={(value) =>
                          onChangePremData(value, index, "awsUrl")
                        }
                        minLength={length_Ten}
                      />
                    </div>
                    <div className="d-flex align-items-center">
                      <LabelField labelName={"Package Language"} isRequired />
                      <Dropdown
                        labelName="Select Package Language"
                        setInputText={(value) =>
                          onChangePremData(value, index, "languageId")
                        }
                        options={languageList}
                        value={languageId}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
        {!addValidation() && (
          <div className="d-flex justify-content-end">
            <AddMorebtn
              handleClick={onPressAddPremier}
              disable={addValidation()}
            />
          </div>
        )}
      </div>
    );
  };
  const renderSecondForm = () => {
    return (
      <div className="p-2 border rounded-2">
        <div className="d-flex ">
          <LabelField labelName={"Lecture Details"} />
          <div className="w-100 p-1">{renderThirdForm()}</div>
        </div>
      </div>
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const updatedPremierdateArr = premierdateArr.map((obj) => {
      const updatedObj = { ...obj };

      delete updatedObj.local;

      if (!updatedObj.url) {
        delete updatedObj.url;
      }
      if (updatedObj?.languageId?._id) {
        updatedObj.languageId = updatedObj.languageId._id;
      }
      return updatedObj;
    });

    dispatch(
      uploadTeacherImg(selectedImage, async (resp) => {
        let reqBody = {
          examTypeId: examName?._id,
          subExamTypeId: subExamName?._id,
          baseCourseId: parentCourseVal?._id,
          subjectId: subjectVal?._id,
          teacherImage: resp?.file,
          teacherId: teacherName?._id,
          // order: parseInt(order),
          teacherFreeLecture: updatedPremierdateArr,
        };
        dispatch(
          addTeacherData(reqBody, async () => {
            setResetExam(true);
            setResetSubExam(true);
            setResetParentCourse(true);
            setResetTeacherList(true);
            setpremierdateArr([initialValPremier]);
            setSelectedImage("");
            setTeacherImage("");
            // setOrder("");
          })
        );
      })
    );
  };

  const validateArray = () => {
    return premierdateArr?.some(
      (item) =>
        !item?.topic ||
        !item?.title ||
        !item?.thumbnail ||
        !item?.awsUrl ||
        !item?.order ||
        !item?.languageId?._id
    );
  };

  const validations = () => {
    return (
      examName === "" ||
      parentCourseVal === "" ||
      teacherName === "" ||
      selectedImage === "" ||
      // order === "" ||
      validateArray()
    );
  };

  const onChangePremData = (value, index, key) => {
    let newArr = JSON.parse(JSON.stringify(premierdateArr));
    if (key === "topic") {
      newArr[index].topic = value;
      setpremierdateArr(newArr);
    } else if (key === "title") {
      newArr[index].title = value;
      setpremierdateArr(newArr);
    } else if (key === "order") {
      if (/^\d*$/.test(value)) {
        newArr[index].order = value;
        setpremierdateArr(newArr);
      }
    } else if (key === "thumbnail") {
      if (!validateIsFileImageType(value)) {
        dispatch(showErrorSnackbar(validateIsFileImageTypeErrMsg));
        return;
      }
      if (value.target.files[0].size > pdf_size_1MB) {
        dispatch(showErrorSnackbar("File size should be less than 1 MB!!!"));
      } else {
        const file = value.target.files[0];
        dispatch(
          uploadYoutubeReferredImage(file, (resCover) => {
            if (resCover) {
              const reader = new FileReader();
              reader.onloadend = () => {
                newArr[index].thumbnail = resCover.link;
                newArr[index].local = reader.result;
                setpremierdateArr(newArr);
              };
              reader.readAsDataURL(file);
            } else {
              dispatch(showErrorSnackbar("File Not Uploaded"));
            }
          })
        );
      }
    } else if (key === "url") {
      newArr[index].url = value;
      setpremierdateArr(newArr);
    } else if (key === "awsUrl") {
      newArr[index].awsUrl = value;
      setpremierdateArr(newArr);
    } else if (key === "languageId") {
      newArr[index].languageId = value;
      setpremierdateArr(newArr);
    }
  };

  const addValidation = () => {
    return premierdateArr?.length === 5;
  };

  useEffect(() => {
    dispatch(
      getExamListNew((res) => {
        setExamList(res);
      })
    );
  }, []);
  return (
    <div className="contentBox">
      <PageTitle name={"ADD FREE YT LECTURE"} />
      <div className="formDiv contentScrollbar">
        <form className="formWidth col-md-7" onSubmit={handleSubmit}>
          {renderFirstForm()}
          {renderSecondForm()}
          <div className="my-2 d-flex justify-content-end align-items-center">
            <SubmitButton name="Save" validations={validations()} />
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddFreeYTLectures;
